import { apiFetch } from '../services/api';

// Shared payment path used by BOTH the full checkout form and the product-page
// express (Apple/Google Pay) buttons, so there is one proven implementation of
// "create the PaymentIntent + confirm the payment". The SERVER computes the
// real charge amount from product_slug + variant + customer postcode, so this
// stays the single source of truth for what's charged.
//
// payload: { product_slug, width, projection, colour: {name,code}|null, customer, notes, referrer }
// Throws Error(message) on any failure; resolves with the create-intent
// response ({ clientSecret, orderToken }) on success (payment confirmed or
// requiring no further action).
export async function submitPayment({ stripe, elements, payload, returnUrl, receiptEmail }) {
  const { error: submitError } = await elements.submit();
  if (submitError) throw new Error(submitError.message || 'Please check your payment details.');

  const res = await apiFetch('/api/checkout/create-intent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Could not start checkout.');

  // SEC-19: store the random public token (not the _id) so the success page
  // can look the order up without leaking recent ids.
  try { sessionStorage.setItem('asg.lastOrderToken', data.orderToken); } catch { /* ignore */ }

  const confirm = await stripe.confirmPayment({
    elements,
    clientSecret: data.clientSecret,
    confirmParams: { return_url: returnUrl, receipt_email: receiptEmail },
    redirect: 'if_required',
  });
  if (confirm.error) throw new Error(confirm.error.message || 'Payment failed. Please try again.');
  return data;
}
